export default __webpack_public_path__ + "static/media/lighted_coffin.8c8075da.png";